/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from 'app/routes';
import { useParseOrgs } from 'app/utils/hooks/useParseOrgs';
import { Button, Modal, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { ColorsV2 } from 'app/constants/color';
import { Buttons } from 'app/constants/sizing';
import { useSwapToken } from 'app/utils/hooks/useSwapToken';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';

const OrgSelect = () => {
  const { redirect, orgs } = useParseOrgs();
  const navigate = useNavigate();
  const swapToken = useSwapToken();

  useEffect(() => {
    if (redirect) {
      navigate(routes.HOME);
    }
  }, []);

  const handleSelect = async(orgId) => {
    swapToken(orgId);
  };


  return (
    <Modal open={true} sx={{
      outline: 0,
    }}>
        <Stack
        direction='column'
        alignItems='center'
        justifyContent='space-between'
        gap='10px'
        sx={{
          minWidth: '300px',
          minHeight: '300px',
          backgroundColor: ColorsV2.secondary,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          padding: '20px',
          borderRadius: '4px',
        }}
        >
          <Stack direction='column' alignItems='center' gap='10px'>
            <Typography variant='h4' sx={{ color: ColorsV2.white, maxWidth: '360px' }}>Select an organisation</Typography>
            <Stack direction='column' alignItems='center' gap='10px' sx={{
            maxHeight: '260px',
            overflow: 'scroll',
            }}>
              {orgs.map && orgs.map((org, index) => {
                return(
                  <Stack direction='row' alignItems='center' key={org.id ? org.id : 'no id found:' + org.name + index} >
                    <Button 
                    onClick={() => handleSelect(org.id)} 
                    sx={{
                      ...Buttons.baseStyle.primaryButtonLowPriority,
                      justifyContent: 'flex-start',
                      minWidth: '400px',
                      maxWidth: '500px'
                    }}>
                      <BusinessOutlinedIcon sx={{ marginRight: '10px'}} />
                      {org.name}
                    </Button>
                  </Stack>
                )
              })}
            </Stack>
          </Stack>
          <Button onClick={() => navigate(routes.HOME)} sx={{
            ...Buttons.baseStyle.primaryButtonLowPriority,
            alignSelf: 'flex-start',
          }}>
            Cancel
          </Button>
      </Stack>
    </Modal>
  );
};

export default OrgSelect;